import { sanitizeHTML } from '@/lib/utils'
import Link from 'next/link'

interface SecImgTextProps {
	data: {
		heading?: {
			title?: string
		}
		text_left_section?: {
			text?: string
		}
		text_right_section?: {
			text?: string
		}
		button?: {
			label?: string
			href?: string
		}
		options_page: string[]
		background: string
		id_section: string
		class_section: string
	}
}

export const fields = [
	// headings
	'heading.title',

	// text
	'text_left_section.text',
	'text_right_section.text',

	'button.label',
	'button.href',

	'id_section',
	'class_section',
	'options_page',
	'background',
] as const

export default function SecTwoCol({ data }: SecImgTextProps) {
	if (!data) return null

	const textWhite = data?.options_page?.includes('text-white')
	
	return (
		<section
			id={data.id_section || undefined}
			className={`SecTwoCol w-full py-16 ${data.class_section || ''}`}
			{...(data.background && {
				style: { backgroundColor: data.background },
			})}
		>
			<div className={`container ${textWhite ? 'text-white' : ''}`}>
				{data.heading?.title && (
					<h2
						className={`grid gap-2 md:gap-8 w-full mb-8 md:mb-16 md:text-center`}
						dangerouslySetInnerHTML={sanitizeHTML(data.heading.title)}
					/>
				)}

				<div className={`grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-16`}>
					{/* Left Column */}
					<div
						className='flex flex-col gap-6'
						dangerouslySetInnerHTML={sanitizeHTML(data.text_left_section?.text || '')}
					/>

					{/* Right Column */}
					<div
						className='flex flex-col gap-6'
						dangerouslySetInnerHTML={sanitizeHTML(data.text_right_section?.text || '')}
					/>
				</div>
				<div className='relative flex mt-12 max-md:mb-12 justify-center'>
				{data?.button?.label && (
					<Link
						href={data.button?.href || '/'}
						className='btn'
					>{data.button.label}
					</Link>
				)}
				</div>
			</div>
		</section>
	)
}
